import { AppContextProvider } from '@aspendental/shared-components-web';
import TAGThemeProvider from '@aspendental/shared-components-web/lib/theme/TAGThemeProvider';
import { TAGBrand } from '@aspendental/shared-components-web/lib/types';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { StyledEngineProvider, GlobalStyles } from '@mui/material';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Client, Provider, fetchExchange } from 'urql';
import { FacilityContextProvider } from './FacilityContextProvider';
import SessionInitializer from '@src/components/SessionInitializer/SessionInitializer';
import { LOCAL_VETSPIRE_URL } from '@src/constants';
import { theme } from '@src/theme/theme';
const client = new Client({
  url: LOCAL_VETSPIRE_URL,
  exchanges: [fetchExchange],
  requestPolicy: 'network-only'
});
export const ContextProviders = ({
  config,
  preview,
  environment,
  children,
  user
}) => {
  const router = useRouter();
  const brandTheme = config?.themeId || process.env.TAG_BRAND_THEME || 'wellnow';
  const brandName = brandTheme as TAGBrand;
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return <Provider value={client} data-sentry-element="Provider" data-sentry-component="ContextProviders" data-sentry-source-file="ContextProviders.tsx">
			<ContentfulLivePreviewProvider locale={router.locale || 'en-US'} enableInspectorMode={preview} enableLiveUpdates={preview} data-sentry-element="ContentfulLivePreviewProvider" data-sentry-source-file="ContextProviders.tsx">
				<AppContextProvider config={config} theme={brandName} environment={environment} appName={process.env.APP_NAME || 'tag_dev'} appVersion={`${process.env.APP_VERSION || 'unknown'}(design-system:${process.env.DESIGN_SYSTEM_VERSION})`} data-sentry-element="AppContextProvider" data-sentry-source-file="ContextProviders.tsx">
					<StyledEngineProvider injectFirst data-sentry-element="StyledEngineProvider" data-sentry-source-file="ContextProviders.tsx">
						<GlobalStyles styles={{
            'html, body, #__next, #mui-scoped-baseline, #v2-root': {
              height: '100%'
            },
            '#__next': {
              backgroundColor: theme.palette.neutrals[50]
            },
            '#v2-root': {
              display: 'flex',
              flexDirection: 'column'
            }
          }} data-sentry-element="GlobalStyles" data-sentry-source-file="ContextProviders.tsx" />
						<TAGThemeProvider branding={brandName as TAGBrand} data-sentry-element="TAGThemeProvider" data-sentry-source-file="ContextProviders.tsx">
							{isClient && <SessionInitializer />}
							<FacilityContextProvider siteId={typeof router.query.fc === 'string' ? router.query.fc : Array.isArray(router.query.fc) ? router.query.fc[0] ?? '' : ''} appName="tag_dev" appVersion="0.0.0" brand={brandName as TAGBrand} user={user} data-sentry-element="FacilityContextProvider" data-sentry-source-file="ContextProviders.tsx">
								{children}
							</FacilityContextProvider>
						</TAGThemeProvider>
					</StyledEngineProvider>
				</AppContextProvider>
			</ContentfulLivePreviewProvider>
		</Provider>;
};